import { format } from "date-fns";
import { nl } from "date-fns/locale";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import DeviceIcon from "./DeviceIcon";
import { parseUserAgent } from "@/utils/userAgentParser";

interface SessionCardProps {
  session: {
    id: string;
    created_at: string;
    expires_at: string;
    user_agent: string | null;
    session_token: string | null;
  };
  isCurrentSession: boolean;
  onLogout: (sessionId: string) => void;
  isLoggingOut: boolean;
}

const SessionCard = ({ session, isCurrentSession, onLogout, isLoggingOut }: SessionCardProps) => {
  const deviceInfo = parseUserAgent(session.user_agent);
  
  return (
    <Card className="p-4">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3 flex-1">
          <DeviceIcon 
            browser={deviceInfo.browser}
            os={deviceInfo.os}
            deviceType={deviceInfo.deviceType}
            className="w-8 h-8 text-muted-foreground mt-1"
          />
          
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <span className="font-medium">
                {deviceInfo.os} • {deviceInfo.browser} {deviceInfo.browserVersion}
              </span>
              {isCurrentSession && (
                <Badge variant="default" className="ml-2">
                  Huidige sessie
                </Badge>
              )}
            </div>
            
            <div className="text-sm text-muted-foreground space-y-1">
              <div>
                Aangemeld: {format(new Date(session.created_at), "d MMMM yyyy 'om' HH:mm", { locale: nl })}
              </div>
              <div>
                Verloopt: {format(new Date(session.expires_at), "d MMMM yyyy 'om' HH:mm", { locale: nl })}
              </div>
            </div>
          </div>
        </div>
        
        {!isCurrentSession && (
          <Button
            variant="destructive"
            size="sm"
            onClick={() => onLogout(session.id)}
            disabled={isLoggingOut}
          >
            {isLoggingOut ? "Bezig..." : "Log uit"}
          </Button>
        )}
      </div>
    </Card>
  );
};

export default SessionCard;
